/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectPortfolioMonthByMonthClientDownload_viewer = {
    readonly id: string;
    readonly company: {
        readonly currency: string | null;
        readonly financialBasedClients: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly aggregatedFinancialNumbers: ReadonlyArray<string | null>;
                    readonly timeAggregatedFinancialNumbers: ReadonlyArray<string | null>;
                    readonly expenseAggregatedFinancialNumbers: ReadonlyArray<string | null>;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "ProjectPortfolioMonthByMonthClientDownload_viewer";
};
export type ProjectPortfolioMonthByMonthClientDownload_viewer$data = ProjectPortfolioMonthByMonthClientDownload_viewer;
export type ProjectPortfolioMonthByMonthClientDownload_viewer$key = {
    readonly " $data"?: ProjectPortfolioMonthByMonthClientDownload_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectPortfolioMonthByMonthClientDownload_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v2 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v7 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v8 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v9 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v10 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v11 = {
  "kind": "Literal",
  "name": "fetchOwnData",
  "value": true
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "timeSearchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "expenseSearchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedSingleValue",
      "type": "FinancialAggregatedNumber!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ignoreBaselineWinChance",
      "type": "Boolean"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeOpportunityActuals",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioMonthByMonthClientDownload_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            },
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "concreteType": "ClientTypeConnection",
          "kind": "LinkedField",
          "name": "financialBasedClients",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Client",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/)
                      ],
                      "kind": "ScalarField",
                      "name": "aggregatedFinancialNumbers",
                      "storageKey": null
                    },
                    {
                      "alias": "timeAggregatedFinancialNumbers",
                      "args": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        (v11/*: any*/),
                        (v7/*: any*/),
                        {
                          "kind": "Variable",
                          "name": "searchQuery",
                          "variableName": "timeSearchQuery"
                        },
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/)
                      ],
                      "kind": "ScalarField",
                      "name": "aggregatedFinancialNumbers",
                      "storageKey": null
                    },
                    {
                      "alias": "expenseAggregatedFinancialNumbers",
                      "args": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        (v11/*: any*/),
                        (v7/*: any*/),
                        {
                          "kind": "Variable",
                          "name": "searchQuery",
                          "variableName": "expenseSearchQuery"
                        },
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/)
                      ],
                      "kind": "ScalarField",
                      "name": "aggregatedFinancialNumbers",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '71635f2ac1eca0a29fde67b4c47802fb';
export default node;
